import { ActionTypes } from '../actions';

const INITIAL_STATE = {
  currQuestion: null,
  currSurvey: null,
  numCompleted: null,
  surveys: {},
  answers: {},
};

const SurveyReducer = (state = INITIAL_STATE, action) => { // changes state value by 1
  switch (action.type) {
    case ActionTypes.UPDATE_SURVEY:
      return {
        ...state,
        ...action.payload,
      };
    case ActionTypes.CLEAR_ANSWER_HISTORY:
      return state;
    default:
      return state;
  }
};

export default SurveyReducer;
